import { Select } from 'antd'
import { SelectProps } from 'antd/es/select'
import { SizeType } from 'antd/lib/config-provider/SizeContext'
import clsx from 'clsx'
import React, { FC } from 'react'

import styles from './pure-select.module.scss'

interface PureSelectProps extends SelectProps {
  onChange: (value: string) => void
  options: any[]
  isDisabled?: boolean
  isLoading?: boolean
  label?: string
  value: any
  placeholder: string
  colClass?: string
  moduleStyle?: string
  multiple?: boolean
  size?: SizeType
  error?: string | string[]
  required?: boolean
}

export const PureSelect: FC<PureSelectProps> = ({
  value,
  placeholder,
  options,
  colClass,
  moduleStyle,
  label = '',
  onChange,
  multiple = false,
  size,
  error,
  required = false,
  ...rest
}) => {
  return (
    <div className={clsx(colClass || 'col-12', moduleStyle || '', styles.selectStyles)}>
      {label ? (
        <div className="label d-block mt-2 mb-1">
          {label}
          {required ? <span className={clsx('requiredAsterisk')}>*</span> : null}
        </div>
      ) : null}
      <Select
        className={styles.antSelect}
        disabled={false}
        mode={multiple ? 'multiple' : undefined}
        onChange={onChange}
        options={options}
        placeholder={placeholder}
        size={size}
        value={value}
        {...rest}
      />
      {error ? <div className="error-message mt-1">{error}</div> : null}
    </div>
  )
}
